import { get } from 'lodash';
import React from 'react';
import { Field } from 'redux-form';
import RenderInput from '../../../../common/components/Form/RenderInput';
import { required as requiredRule } from '../../../../common/services/ValidationRules';

// TODO Tech Dept
export const renderTextField = (field, props) => {
  // Task https://iotecha.atlassian.net/browse/I2P2-13140
  // If address is filled and Charger Condition is pending
  // we should set Charger Name as required
  // maybe not a best solution
  const conditionValue = get(props, 'formValues.i2p2_state.c_condition');
  const isNotEmptyAddressValue = Boolean((get(props, 'c_address') || '').trim());
  const addressFieldFirst = conditionValue === 'pending' && field.addressPendingRequired && isNotEmptyAddressValue;

  const required = addressFieldFirst || field.starred;
  let validate = field.validate;

  if (addressFieldFirst) {
    validate = [...field.validate, requiredRule];
  }

  return <Field {...field} required={required} key={field.name} component={RenderInput} validate={validate} fullWidth />;
};
